// import external dependencies
import 'jquery';


var fixedHeaderHeight = 50;

var target = window.location.hash;
target = target.replace('#', '');

//window.location.hash = '';

$(window).on('load', function() {

    // scroll to from hash using class name #some-link scrolls to first instance of .some-link
   setTimeout(function(){
       if (target) {
           var $target;
           var $matchingTargets = $('.' + target);
           if ($matchingTargets.length == 1) {
                $target = $matchingTargets;
           } else if ($matchingTargets.length > 1) {
                $target = $matchingTargets.first();
           }

           if ($target.length == 1) {

               $('header').css('position', 'fixed'); // makes header fixed to calculate correct top

               window.scrollTo(0, 0); // reset back to 0
               //var newTop = $('a[name=' + target + ']').offset().top - 20;
               var newTop = $target.offset().top - fixedHeaderHeight;

               $('html, body').animate({
                   scrollTop: newTop,
               }, 700, 'swing', function () {
                   $('header').css('position', ''); // remove header from being fixed
               });
           }
       }
   }, 1);


});


(function($) {

    $(document).ready(function(){
        init();
        initializeCookieConsentPopup();
    });

    function init() {
        wireupStickyHeader();
        wireupSmoothScrollingAnchorClicks();
        wireupScrollTopButton();
        wireupSearch();
    }

    function wireupSearch() {
        wireupSearchIcon();
        wireupAppendSearchboxToMeganav();
        wireupCloseButton();
    }

    function wireupSearchIcon() {
        $('.button_toggle-search').click(function() {
            var $nav = $('nav.nav-primary');
            if ($nav.hasClass('show-search')) {
                $nav.removeClass('show-search');
            } else {
                $nav.addClass('show-search');
            }
        });
    }

    function wireupCloseButton() {
        $('.form_header-search').find('.button_close').click(function(){
           var $nav = $('nav.nav-primary');
           returnSearchboxToDefaultPosition();
           $nav.removeClass('show-search');
        });
    }

    function wireupAppendSearchboxToMeganav() {
        $('nav.nav-primary .menu-main-menu-container ul.nav > li.has-meganav').hover(
            function() {
                let $item = $(this);
                let $nav = $item.closest('nav.nav-primary');
                if ($nav.hasClass('show-search')) {
                    appendSearchboxToMenuItem($item);
                }
            },
            function() {
                let $item = $(this);
                let $nav = $item.closest('nav.nav-primary');
                if ($nav.hasClass('show-search')) {
                    returnSearchboxToDefaultPosition();
                }
            }
        )
    }

    function appendSearchboxToMenuItem($item) {

        let $searchbox = $('nav.nav-primary .form_header-search');
        if ($searchbox.hasClass('desktop-search')) { // don't move it on search results page or mobile
            let $container = $item.find('.serenity-meganav-container');
            $container.prepend($searchbox);
            $searchbox.find('input[name="search"]').focus();
        }
    }

    function returnSearchboxToDefaultPosition() {

        let $searchbox = $('nav.nav-primary .form_header-search');
        let $container = $('nav.nav-primary .panel_desktop-search');
        $container.append($searchbox);
        $searchbox.find('input[name="search"]').focus();
    }

    function initializeCookieConsentPopup() {

        window.cookieconsent.initialise({
          container: document.getElementById('cookieconsent'),
          palette:{
            popup: { text: '#fff', background: '#0d414b' },
            button: { text: '#fff', background: '#e0684a' },
          },
          revokable: false,
          onStatusChange: function(status) {
            console.log('cookies', status, this.hasConsented() ?
            'enable cookies' : 'disable cookies');
          },
          'theme': 'edgeless',
        });
    }

    function wireupStickyHeader() {

        var $header = $('header.banner');
        stickPanelToTop($header);

        var $content = $('div.wrap[role="document"]');
        var startFixed = $header.offset().top;

        $(document).scroll(function() {

            var scrollHeight = $(window).scrollTop();

            if (scrollHeight > startFixed) {
                $content.addClass('sticky-header');
            } else {
                $content.removeClass('sticky-header');
            }
        });

    }

    function wireupScrollTopButton() {

        var $buttonPanel = $('.panel_scroll-top');
        var $button = $buttonPanel.find('.button_scroll-top');
        $button.click(function() {
           $('html, body').animate({
               scrollTop: 0,
           }, 700, 'swing');
        });


        $(document).scroll(function() {

            var scrollHeight = $(window).scrollTop();
            var startHeight = 200;

            if (scrollHeight > startHeight) {
                $buttonPanel.addClass('active');
            } else {
                $buttonPanel.removeClass('active');
            }
        });
    }

    function wireupSmoothScrollingAnchorClicks() {
        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();
            var $link = $(this);
            var href = $link.attr('href');
            if (href != '#') {
                var selector = href.replace('#', '.');

                var $target;
                var $matchingTargets = $(selector);
                if ($matchingTargets.length == 1) {
                    $target = $matchingTargets;
                } else if ($matchingTargets.length > 1) {
                    $target = $matchingTargets.first();
                }

                if ($target.length == 1) {

                    $('body').removeClass('open-nav');
                    $('html, body').animate({
                        scrollTop: $(selector).offset().top - fixedHeaderHeight,
                    }, 500);
                }
            }
        });
    }

    function stickPanelToTop($element, offset, className) {

        if (!offset) {
            offset = 0;
        }

        if (!className) {
            className = 'sticky';
        }

        var startFixed = $element.offset().top + offset;

        $(document).scroll(function() {

            var scrollHeight = $(window).scrollTop();

            if (scrollHeight > startFixed) {
                $element.addClass(className);
            } else {
                $element.removeClass(className);
            }

            /*
            if (scrollHeight > startFixed) {
                $element.css('position', 'fixed');
                $element.css('top', '0px');
                $element.css('margin-top', '0');
            } else {
                $element.css('position', '');
                $element.css('top', '');
                $element.css('margin-top', '');
            }
            */
        });
    }



})(jQuery);



// WEBPACK FOOTER //
// ./scripts/serenity-nav.js